import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import OptionRow from './OptionRow.tsx';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';

const AddonRow = ({ addon }: any) => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <TableRow>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }}>
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell
                    sx={{ backgroundColor: "#f3f3f3" }}
                    align="left"
                >
                    <div className='fooditemTableHeader d-flex flex-row align-items-center'>
                        <Typography>{addon.addOnName}</Typography>
                        <Typography
                            sx={{ backgroundColor: "#f3f3f3", color: 'rgba(220, 53, 69, 1)', fontWeight: 'bold', fontSize: '12px', height: '20px' }}
                            align="center"
                            className='fooditemTableHeader'
                        >{addon.refundStatus}</Typography>
                    </div>
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center" className='fooditemTableHeader'>£ {(addon.vatInAmount * addon.qty).toFixed(2)}</TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center" className='fooditemTableHeader'>£ {(addon.sdInAmount * addon.qty).toFixed(2)}</TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center" className='fooditemTableHeader'>{addon.qty}</TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center" className='fooditemTableHeader'>£ {addon.basePrice} </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center" className='fooditemTableHeader'>£ {addon.basePrice * addon.qty}</TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center" className='fooditemTableHeader'>£ {addon.totalPrice}</TableCell>
            </TableRow>

            {addon.options.length > 0 &&
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit sx={{ width: "110%" }}>
                            <Box sx={{ margin: 1 }}>
                                <Typography variant="h6" gutterBottom>
                                    Options
                                </Typography>
                                <Table size="small" aria-label="food-items">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell align='left'>Option Name</TableCell>
                                            <TableCell align='center'>VAT Per Option</TableCell>
                                            <TableCell align='center'>SD Per Option</TableCell>
                                            <TableCell align='center'>Option Quantity</TableCell>
                                            <TableCell align='center'>Option Base Price</TableCell>
                                            <TableCell align='center' style={{ textWrap: 'nowrap' }}>Sub Total</TableCell>
                                            <TableCell align='center'>Option Total Price</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {open && addon.options.map((option, index) => (
                                            <OptionRow key={index} option={option} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            }
        </>
    );
};

export default AddonRow;